import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Warning } from "@phosphor-icons/react";
import Logo from "@/components/Logo";

const KEY = "ve_age_verified";

export default function AgeGate() {
  const [open, setOpen] = useState(false);
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    const val = localStorage.getItem(KEY);
    if (val !== "yes") setOpen(true);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "yes");
    setOpen(false);
  };
  const decline = () => {
    localStorage.setItem(KEY, "no");
    setBlocked(true);
  };

  if (!open && !blocked) return null;

  return (
    <AnimatePresence>
      {(open || blocked) && (
        <motion.div
          key="agegate"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          data-testid="age-gate-overlay"
          className="fixed inset-0 z-[100] flex items-center justify-center p-4 backdrop-blur-md"
          style={{
            background:
              "radial-gradient(1200px 800px at 30% 20%, rgba(255,90,31,0.18), transparent 60%), radial-gradient(1000px 600px at 70% 80%, rgba(0,255,194,0.14), transparent 60%), rgba(0,0,0,0.94)",
          }}
        >
          <motion.div
            initial={{ scale: 0.9, y: 30, opacity: 0 }}
            animate={{ scale: 1, y: 0, opacity: 1 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            className="relative w-full max-w-lg border border-white/15 bg-[#0a0a0a] p-8 md:p-10"
          >
            <div className="flex items-center gap-3">
              <Logo size={40} showWord={false} testId="agegate-logo" />
              <div>
                <div className="font-label text-[10px] text-white/50">/ AGE VERIFICATION</div>
                <div className="font-display text-xl font-black tracking-tighter">Vape Essence</div>
              </div>
            </div>

            {!blocked ? (
              <>
                <h1 className="mt-8 font-display text-3xl font-black tracking-tighter md:text-4xl">
                  Are you <span className="text-[#FF5A1F]">18</span> or older?
                </h1>
                <p className="mt-4 text-sm leading-relaxed text-white/60">
                  Vape Essence products contain nicotine. Nicotine is an addictive chemical. By
                  entering this site you confirm you are of legal smoking / vaping age in your
                  region (18+ in South Africa).
                </p>
                <div className="mt-4 flex items-start gap-2 border border-white/10 bg-white/5 p-3 text-xs text-white/50">
                  <Warning size={16} weight="duotone" className="mt-[2px] shrink-0 text-[#FFC900]" />
                  <span>
                    Not for sale to minors, pregnant or breastfeeding women, persons with heart
                    conditions, high blood pressure, diabetes, or those sensitive to nicotine.
                  </span>
                </div>

                <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                  <button
                    data-testid="age-gate-accept"
                    onClick={accept}
                    className="flex-1 bg-[#FF5A1F] py-4 font-label text-xs text-black transition-transform hover:-translate-y-0.5 hover:shadow-[0_16px_40px_rgba(255,90,31,0.35)]"
                  >
                    I am 18 or older — Enter
                  </button>
                  <button
                    data-testid="age-gate-decline"
                    onClick={decline}
                    className="flex-1 border border-white/20 py-4 font-label text-xs text-white/70 hover:border-[#FF5A1F] hover:text-[#FF5A1F] transition-colors"
                  >
                    I am under 18
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="mt-8 flex items-center gap-3">
                  <X size={28} weight="bold" className="text-[#FF5A1F]" />
                  <h1 className="font-display text-3xl font-black tracking-tighter">
                    Come back <span className="text-white/40">when you're older</span>.
                  </h1>
                </div>
                <p className="mt-6 text-sm leading-relaxed text-white/60">
                  You must be 18 or older to browse Vape Essence. Please close this window.
                </p>
                <p className="mt-6 text-xs text-white/40">
                  If you reached this in error,{" "}
                  <button
                    onClick={() => {
                      localStorage.removeItem(KEY);
                      setBlocked(false);
                    }}
                    className="text-[#00FFC2] underline hover:text-white"
                  >
                    verify again
                  </button>
                  .
                </p>
              </>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
